import { render, staticRenderFns } from "./Feature5.vue?vue&type=template&id=5bad2b99&"
import script from "./Feature5.vue?vue&type=script&lang=js&"
export * from "./Feature5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports